import React from 'react';
import { motion } from 'framer-motion';
import { brand } from '../data/brand';
export function Hero() {
  return <section id="top" aria-label="ELORA Fine Jewelry" className="relative w-full overflow-hidden bg-white" data-id="element-144" data-mp="eiv5ox3vlaku">
      <img src={brand.hero} alt="18K gold chain necklace and hoop earrings on white marble beside ivory silk" className="absolute inset-0 h-full w-full object-cover object-[50%_28%] md:object-center" data-id="element-145" data-mp="9l33na9io82x" />
      <div className="absolute inset-0 bg-black/15" aria-hidden="true" data-id="element-146" data-mp="xano5xlbjdeb" />

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative mx-auto flex min-h-[58vh] max-w-editorial items-end justify-center px-6 pb-14 pt-32 md:min-h-[76vh] md:px-12 md:pb-20 md:pt-48 lg:px-20" data-id="element-147" data-mp="x8b7rov7lb3d">
        <a href={brand.shopAllHref} className="inline-flex min-h-[54px] w-full max-w-xs items-center justify-center border border-white bg-transparent px-14 font-serif text-[14px] font-light uppercase tracking-[0.32em] text-white transition-colors duration-150 ease-luxe hover:bg-white/10 focus-visible:bg-white/10 focus-visible:outline-none md:w-auto md:max-w-none md:min-h-0 md:py-[18px] md:text-[15px]" data-id="element-148" data-mp="381xn73sg3cct">
          Shop all
        </a>
      </motion.div>
    </section>;
}